import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { api } from './api';
import type { Me, TenantInfo } from './types';

export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: () => api.get<Me>('/api/me'), staleTime: 60_000, retry: false });
}

export function useTid() {
  return useParams().tid!;
}

export function useTenant(tid: string) {
  return useQuery({ queryKey: ['tenant', tid], queryFn: () => api.get<TenantInfo>(`/api/t/${tid}`), staleTime: 60_000, retry: false });
}

export function useMedia(query: string) {
  const [match, setMatch] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setMatch(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, [query]);
  return match;
}

export const useIsDesktop = () => useMedia('(min-width: 760px)');

export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    if (title) document.title = `${title} · Mesa`;
  }, [title]);
}
